export default {
  SET_RESTAURANT (state, payload) {
    state.restaurant = payload

  },
  SET_CHECKOUT_RESTAURANT (state, payload) {
    state.checkout_restaurant = payload

  },
  SET_RESTAURANT_LIST (state, payload) {
    state.restaurantlist = payload
  },
  SET_AREA_LIST (state, payload) {
    state.arealist = payload
  },
  SET_RESTAURANT_LIST_ALL (state, payload) {
    state.restaurantlistall = payload
  },
  SET_CATERING_RESTAURANT_LIST (state, payload) {
    state.cateringRestaurantlist = payload
  },
  SET_ORDER_LIST (state, payload) {
    state.orderList = payload
  },
  SET_CONTENTS (state, payload) {
    state.contents = payload
  },
  SET_COUPONS (state, payload) {
    state.coupons = payload
  },
  SET_CURRENT_CONTENT (state, payload) {
    state.current_content = payload
  },
  PASS (state, payload) {
    state.pass = payload
  },
  SET_SELECTED_CITY (state, payload) {
    state.selected_city = payload
  },
  SET_DELIVERY_METHOD (state, payload) {
    state.deliveryMethods = payload
  },
  SET_SELECTED_IMAGE (state, payload) {
    state.selected_image = payload
  },
  SET_PAGE_CONTENTS (state, payload) {
    state.page_contents = payload
  },
  SET_BLOG_CONTENTS (state, payload) {
    state.blog_contents = payload
  },
  SET_COUPON_BANNER_CONTENTS (state, payload) {
    state.couponBannerContents = payload
  },
  SET_COUPON_SLIDE_CONTENTS (state, payload) {
    state.couponSlideContents = payload
  },
  SET_SPECIAL_SLIDE_CONTENTS (state, payload) {
    state.specialSlideContents = payload
  },
  SET_EVENT_SLIDE_CONTENTS (state, payload) {
    state.eventSlideContents = payload
  },
  SET_SEARCH_DATA (state, payload) {
    state.searchData = payload
  },
  SET_SEARCH_RESULT_DATA (state, payload) {
    state.searchResultData = payload
  },
  SET_SEARCH_RESTAURANT_DATA (state, payload) {
    state.searchRestaurantData = payload
  },
  SET_LOGGED_IN (state, payload) {
    state.isLoggedIn = payload
  },
  SET_USER (state, payload) {
    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userData')) || state.currentUser

    for (const property of Object.keys(payload)) {
      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.currentUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }
    }
    // Store data in localStorage
    localStorage.setItem('userData', JSON.stringify(userInfo))
  },
  SET_PRODUCT_CATEGORIES_LIST (state, payload) {
    state.productCategories = payload
  },
  SET_PLACE_SERVICE (state, payload) {
    state.place_service = payload
  },
  SET_CATERING_CATEGORIES_LIST (state, payload) {
    state.cateringCategories = payload
  },
  SET_TOKEN_VALID (state, payload) {
    state.token_valid = payload
  },
  SET_ADDRESS_LIST (state, payload) {
    state.address_list = payload
  },
  SET_COUPON (state, payload) {
    state.coupon = payload
  },
  SET_GIFT (state, payload) {
    state.gift = payload
  },
  SET_SELECTED_DATE_RESULT (state, payload) {
    state.selected_date_result = payload
  },
  SET_DEFAULT_ADDRESS (state, payload) {
    // Store data in localStorage
    state.defaultAddress = payload
    localStorage.setItem('addressInfo', JSON.stringify(state.defaultAddress))
  },
  SET_CHECKOUT_STAGE (state, payload) {
    state.checkout_stage = payload
  },
  SET_CHECKOUT_PAGE (state, payload) {
    state.checkout_page = payload
  },
  SET_MOBILE (state, payload) {
    state.isMobile = payload
  },
  SET_INITED (state, payload) {
    state.isInited = payload
    localStorage.setItem('isInited', payload)
  },
  SET_SHOW_WEBSITE (state, payload) {
    state.showWebsite = payload
  },
  SET_SHOW_RESTAURANT_LOGO (state, payload) {
    state.showRestaurantLogo = payload
  },
  SET_SHOW_CART (state, payload) {
    state.showCart = payload
  },
  SET_CART_BACKGROUND (state, payload) {
    state.isCartBackground = payload
  },
  SET_SCROLLED (state, payload) {
    state.isScrolled = payload
  },
  SET_SHOW_SEARCH (state, payload) {
    state.showSearch = payload
  },
  SET_DELIVERY_ADDRESS (state, payload) {
    // Store data in localStorage
    state.deliveryAddress = payload
    localStorage.setItem('deliveryInfo', JSON.stringify(state.deliveryAddress))
  },
  SET_PRODUCT_LIST (state, payload) {
    state.productlist = payload
  },
  SET_MODIFIER_LIST (state, payload) {
    state.modifierlist = payload
  },
  SET_LIVE_CITY (state, payload) {
    state.liveCities = payload
  },
  SET_GIFT_CARD (state, payload) {
    state.giftCards = payload
  }
}
